var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ReusableLogicInputConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ColumnMetadata } from './columnMetadata';
import { GraphElement } from './graphElement';
import { REUSABLE_LOGIC_PATH_SEPARATOR } from './reusableLogic';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { reusableLogicInputConfigSchemaValidation } from '../validations.generated';
export const reusableLogicInputConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicInputConfig',
    type: 'object',
    properties: {
        inputColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:Column' },
            uniqueItemProperties: ['name'],
            minItems: 1
        }
    },
    required: ['inputColumns']
};
let ReusableLogicInputConfig = ReusableLogicInputConfig_1 = class ReusableLogicInputConfig extends ToolConfig {
    constructor(inputColumns, customFormats) {
        super(ToolType.REUSABLE_LOGIC_INPUT, customFormats);
        this.inputColumns = inputColumns;
        JSON.validate(this, ReusableLogicInputConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return ReusableLogicInputConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return ReusableLogicInputConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return ReusableLogicInputConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return ReusableLogicInputConfig_1.outs;
    }
    static get in() {
        return ReusableLogicInputConfig_1.ins[0];
    }
    static get ins() {
        return ['default'];
    }
    static get out() {
        return ReusableLogicInputConfig_1.outs[0];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo('Input', [ToolCategories.DATA], this.ins, this.outs, ['input'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const exp = tsb.export(this.out);
        this.inputColumns.forEach((c) => {
            // RL Input nodes are only used during initial validation - they get replaced during calc
            // Treating the columns kind of like FileConfig (which resets colOrigins), providing a fake fileID to make it work...
            const sourceColumn = ColumnMetadata.fromFileColumn(GraphElement.newID(), c);
            exp.copy(this.in, sourceColumn, false, true);
        });
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, ins) {
        // RL Input nodes only exist within Reusable Logics
        // Validation occurs in the Reusable Logic Config
        return ToolValidationState.VALID;
    }
    // RL Input tools are expanded into (Select -> Rename) tools when calced. So the S3 location for any results of an input tool will just be
    // the associated Rename tool, which is suffixed by /rename
    static appendRLInputToolOutputSuffix(idPath) {
        return `${idPath}${REUSABLE_LOGIC_PATH_SEPARATOR}rename`;
    }
};
ReusableLogicInputConfig = ReusableLogicInputConfig_1 = __decorate([
    JsonSchemaV2(reusableLogicInputConfigSchema, reusableLogicInputConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.REUSABLE_LOGIC_INPUT)
], ReusableLogicInputConfig);
export { ReusableLogicInputConfig };
//# sourceMappingURL=reusableLogicInputConfig.js.map